// PAB Header — scrolled shadow, mobile panel toggle, announcement carousel.
class PabHeader extends HTMLElement {
  #timer = null;
  #idx = 0;
  #onScroll = null;

  connectedCallback() {
    // The theme's inline script only measures `header-component`, so publish
    // the header height CSS vars (sticky offsets across pab sections use them).
    const setHeight = () => {
      const h = `${this.offsetHeight}px`;
      document.body.style.setProperty('--header-height', h);
      document.body.style.setProperty('--header-group-height', h);
    };
    setHeight();
    new ResizeObserver(setHeight).observe(this);

    // Scrolled state (border + shadow past 8px, like the design)
    this.#onScroll = () => this.classList.toggle('scrolled', window.scrollY > 8);
    window.addEventListener('scroll', this.#onScroll, { passive: true });
    this.#onScroll();

    // Mobile menu toggle
    const burger = this.querySelector('[data-pab-burger]');
    burger?.addEventListener('click', () => {
      const open = this.classList.toggle('menu-open');
      burger.setAttribute('aria-expanded', String(open));
    });
    window.addEventListener('resize', () => {
      if (window.innerWidth > 820) this.classList.remove('menu-open');
    });
    // Close the panel when a link inside it is clicked
    this.querySelector('[data-pab-mnav]')?.addEventListener('click', (e) => {
      if (e.target.closest('a')) this.classList.remove('menu-open');
    });

    // Announcement carousel (mobile)
    this.msgs = [...this.querySelectorAll('[data-pab-abar-msg]')];
    if (this.msgs.length > 1) {
      this.querySelector('[data-pab-abar-prev]')?.addEventListener('click', () => this.#go(-1));
      this.querySelector('[data-pab-abar-next]')?.addEventListener('click', () => this.#go(1));
      const interval = Number(this.dataset.interval) || 4000;
      this.#timer = setInterval(() => this.#set((this.#idx + 1) % this.msgs.length), interval);
    }
  }

  disconnectedCallback() {
    if (this.#timer) clearInterval(this.#timer);
    if (this.#onScroll) window.removeEventListener('scroll', this.#onScroll);
  }

  #go(d) {
    this.#set((this.#idx + d + this.msgs.length) % this.msgs.length);
  }

  #set(i) {
    this.#idx = i;
    this.msgs.forEach((m, j) => m.classList.toggle('on', j === i));
  }
}

if (!customElements.get('pab-header')) customElements.define('pab-header', PabHeader);
